import script from "./PhotographerLearning.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotographerLearning.vue?vue&type=script&setup=true&lang=js"

import "./PhotographerLearning.vue?vue&type=style&index=0&id=33288720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33288720"]])

export default __exports__